<c3-config-section-box
  [title]="TP_SECTIONS_INFO['microlearning'].label"
  [icon]="TP_SECTIONS_INFO['microlearning'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["microlearning"].description }}</p>

  <div [c3ConfigForm]="this">
    <mat-table [dataSource]="dataSource" matSort>
      <!-- Column selection -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="flex-5">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
            *ngIf="dataSource.data.length > 0"
          >
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-5">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="onSelectionChange(row)"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- Column microlearning name -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Microlearning</mat-header-cell>

        <mat-cell *matCellDef="let microlearning" class="layout-row layout-align-start-center">
          <span>{{ microlearning.label }}</span>
        </mat-cell>
      </ng-container>

      <!-- Column startDate -->
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Data d'inizio</mat-header-cell>

        <mat-cell *matCellDef="let microlearning" class="layout-row layout-align-start-center">
          <mat-form-field compact>
            <input
              matInput
              [matDatepicker]="startDatePicker"
              [(ngModel)]="microlearning.startDate"
              (ngModelChange)="onStartDateChange()"
              [disabled]="!selection.isSelected(microlearning)"
              [min]="today"
              readonly
            />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- TABLE HEADER -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div *ngIf="dataSource.data.length === 0" class="empty-list-msg">
      <i>Non sono presenti moduli di microlearning prescrivibili al paziente</i>
    </div>
  </div>
</c3-config-section-box>
